export default "__VITE_ASSET__BUDWYoq4__"